// todo fix loop extends
import '../components/common/UtilsDataProvider';
import AuthDataProvider from '../components/auth/AuthDataProvider';
import { User } from '../models/AdministrativeModels';
import Promise from 'bluebird';
import _ from 'lodash';
import RouterHelper from './RouterHelper';
import PubSub from 'pubsub-js';
import GlobalConst from '../utils/GlobalConst';
import WhiteLabelController from '../core/WhiteLabelController';
import Hotjar from '@hotjar/browser';
import { store } from '../store/store';
import { setAuthState, clearAuthState } from '../store/authSlice';

/*contains global Google Idenity Services API (`window.google.accounts`) */

class UserManager {

	user = User.fromJSON({});
	get authToken() {
		return localStorage.getItem('auth_token');
	}

	set authToken(token) {
		if (token) {
			localStorage.setItem('auth_token', token);
		} else {
			localStorage.removeItem('auth_token');
		}
	}

	clearAuthData() {
		this.authToken = null;
		this.user = User.fromJSON({});
		store.dispatch(clearAuthState());
		localStorage.removeItem('auth_token');
		localStorage.removeItem('auth_token_original_user');
		PubSub.publish('CLEAR_OAUTH');
	}

	syncAuthData() {
		store.dispatch(setAuthState({
			authToken: this.authToken,
			user: this.user,
			isAuthorized: this.isAuthorized,
			isActive: this.user.isActive,
			isImpersonating: this.isImpersonating
		}));
	}

	setUserData(promise, loginAs=false) {
		return promise.then(data => {
			if(_.isEmpty(data)) {
				this.clearAuthData();
			} else {
				const isImpersonating = loginAs ? loginAs : this.isImpersonating;
				this.user = User.fromJSON({...data, isImpersonating});
				this.authToken = this.user.authToken;
				this.setHotjarIdentify();
				this.setPendoInitialize(this.user);
				if (this.user.isActive) {
					PubSub.publish('FETCH_OAUTH_DATA');
					PubSub.publish('TRIGGER_NOTIFICATIONS');
				}
			}
			this.syncAuthData();
			PubSub.publish(GlobalConst.USER_CHANGED_MSG);
			return data;
		});
	}

	setUserDataAvailable(data, fromURL) {
		if(_.isEmpty(data)) {
			this.clearAuthData();
		} else {
			this.user = User.fromJSON(data);
			this.authToken = this.user.authToken;
			this.redirectOnLogin(fromURL);
			this.setHotjarIdentify();
			this.setPendoInitialize(this.user);
			if (this.user.isActive) {
				PubSub.publish('FETCH_OAUTH_DATA');
				PubSub.publish('TRIGGER_NOTIFICATIONS');
			}
		}
		this.syncAuthData();
	}

	redirectOnLogin(from) {
		if(from && from !== '/') {
			RouterHelper.goTo(from);
		} else {
			RouterHelper.goToDefaultRoute();
		}
	}

	setUserAvatar(promise) {
		return promise.then(avatar => {
			this.user.profileImageUrl = avatar;
			PubSub.publish(GlobalConst.USER_CHANGED_MSG);
			return avatar;
		});
	}

	login(userName, password) {
		return AuthDataProvider.login(userName, password);
	}

	register(firstName, lastName, email, password, verifyPassword, company, annualAdSpend, userType, region, country) {
		return this.setUserData(AuthDataProvider.register(User.toJSON({firstName, lastName, email, password, verifyPassword, company, annualAdSpend, userType, region, country})));
	}

	autoLogin(magicToken) {
		if (magicToken) {
			return this.setUserData(AuthDataProvider.autoLogin({magic_token: magicToken}));
		} else if(!this.authToken) {
			return Promise.reject();
		}
		return this.setUserData(AuthDataProvider.autoLogin({auth_token: this.authToken}));
	}

	reloadCurrentUser() {
		return this.autoLogin();
	}

	updateCurrentUser(data) {
		return this.setUserData(AuthDataProvider.updateCurrentUser(User.toJSON(data)));
	}

	updateUserAvatar(blob) {
		return this.setUserAvatar(AuthDataProvider.updateUserAvatar(blob));
	}

	deleteUserAvatar() {
		return this.setUserAvatar(AuthDataProvider.deleteUserAvatar());
	}

	changeUserPassword(currentPassword, newPassword) {
		return AuthDataProvider.changeUserPassword(currentPassword, newPassword).then(() => this.clearAuthData());
	}

	logout() {
		return AuthDataProvider.userLogout()
			.then(() => {
				this.clearAuthData();
				RouterHelper.goToLogin();
				PubSub.publish('CLEAR_TRIGGER_NOTIFICATIONS');
			})
			.catch(() => PubSub.publish(GlobalConst.SHOW_MODAL_MSG, {type: 3, error: 'Error logging out'}));
	}

	loginAsUser(user) {
		if (_.isEmpty(localStorage.getItem('auth_token_original_user'))) localStorage.setItem('auth_token_original_user', this.user.authToken);
		return this.setUserData(AuthDataProvider.loginAsUser(user.id), true);
	}

	loginAsOriginalUser() {
		const originalUserID = localStorage.getItem('auth_token_original_user');
		localStorage.removeItem('auth_token_original_user');
		return this.setUserData(AuthDataProvider.autoLogin({auth_token: originalUserID}))
			.then(() => RouterHelper.goToUserCabinet())
			.then(() => PubSub.publish('UPDATE_USERINFO'));
	}

	changePassword(email, token, password) {
		return AuthDataProvider.changePassword(email, token, password);
	}

	requestPasswordReset(email) {
		return AuthDataProvider.resetPassword(email);
	}

	authByGoogle() {
	    const client = window.google.accounts.oauth2.initCodeClient({
            client_id: this.clientIdGoogle,
            scope: 'profile email https://www.googleapis.com/auth/yt-analytics.readonly https://www.googleapis.com/auth/youtube.readonly',
            callback: ''
        });
        const response = new Promise((resolve, reject) => {
            client.callback = (response) => {
                if (response.error) {
                    reject('Authentication failed');
                }
                resolve({code: response.code});
            };
            client.requestCode();
        });
        return response;
	}

	authByGoogleAdWords() {
	    const client = window.google.accounts.oauth2.initCodeClient({
            client_id: this.clientIdGoogle,
            scope: 'https://www.googleapis.com/auth/adwords https://www.googleapis.com/auth/userinfo.email',
            callback: ''
        });
        const response = new Promise((resolve, reject) => {
            client.callback = (response) => {
                if (response.error) {
                    reject('Authentication failed');
                }
                resolve({code: response.code});
            };
            client.requestCode();
        });
        return response;
	}

	authByDV360() {
	    const client = window.google.accounts.oauth2.initCodeClient({
            client_id: this.clientIdGoogle,
            scope: 'https://www.googleapis.com/auth/display-video https://www.googleapis.com/auth/doubleclickbidmanager https://www.googleapis.com/auth/userinfo.email',
            callback: ''
        });
        const response = new Promise((resolve, reject) => {
            client.callback = (response) => {
                if (response.error) {
                    reject('Authentication failed');
                }
                resolve({code: response.code});
            };
            client.requestCode();
        });
        return response;
	}

	// Meta Oauth
	META_CLIENT_ID = '1245163902747533';
	META_SCOPES = ['email', 'ads_read', 'ads_management', 'business_management'].join(',');
	DEFAULT_REDIRECT_URI = `${window.location.origin}/my_profile`;
	STATE = 'viewiq_meta_oauth';

	buildMetaAuthUrl(redirectUri=this.DEFAULT_REDIRECT_URI) {
		const params = new URLSearchParams({
			client_id: this.META_CLIENT_ID,
			redirect_uri: redirectUri,
			response_type: 'code',
			scope: this.META_SCOPES,
			state: this.STATE
		});
		return `https://www.facebook.com/v23.0/dialog/oauth?${params.toString()}`;
	}

	authByMeta(redirectUri=this.DEFAULT_REDIRECT_URI) {
		window.location.assign(this.buildMetaAuthUrl(redirectUri));
	}

	get isAuthorized() {
		return !_.isEmpty(this.authToken);
	}

	get isImpersonating() {
		const currentAuthToken = localStorage.getItem('auth_token');
		const originalAuthToken = localStorage.getItem('auth_token_original_user');
		if (_.isEmpty(originalAuthToken)) return false;
		if (currentAuthToken === originalAuthToken) return false;
		return true;
	}

	companyName() {
		return WhiteLabelController.siteAssets.name || '';
	}

	get defaultUserIcon() {
		return 'https://viewiq-ui-assets.s3.amazonaws.com/common/default_profile_icon.png';
	}

	get defaultVideoIcon() {
		return 'https://viewiq-ui-assets.s3.amazonaws.com/common/default_video_icon.png';
	}

	get clientIdGoogle() {
		return process.env.NODE_ENV == 'production' && window.location.host.search(/^dev[.-].*\.?iq-series\.com$/) === -1 ?
		'832846444492-jfpnmgjimp6e7m7blfehc647hsddf4np.apps.googleusercontent.com'
		:'832846444492-h9liucgucn7q1okqtb2c71364sqpilg4.apps.googleusercontent.com'
	}

	setHotjarIdentify() {
		const userData = {
			internal: _.includes(this.user.email, '@channelfactory.com'),
			type: this.user.userType
		};
		Hotjar.identify(this.user.id, userData);
	}

	setPendoInitialize(user) {
		window.pendo.initialize({
			visitor: {
				id: user?.id || 'N/A',
				first_name: user?.firstName,
				last_name: user?.lastName,
				user_type: _.includes(user?.email, '@channelfactory.com') ? 'internal' : 'external',
				company: user?.company || 'non-company',
				region_id: user?.region,
				date_joined: user?.registrationDate,
				email: user?.email
			}
		});
	}

}

const manager = new UserManager();
export default manager;
